import axios from 'axios';

axios.defaults.withCredentials = true;

export default axios.create({
  withCredentials: true,
  validateStatus: function (status) {
    return status <= 500;
  },
});
